import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/admin/Sidebar';

const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
const adminPath = process.env.REACT_APP_ADMIN_PATH || '/sh-yonetim-kapisi-x7';

const AdminLayout: React.FC = () => {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const [isSessionLocked, setIsSessionLocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const resetActivityTimer = () => {
    setLastActivityTime(Date.now());
  };

  useEffect(() => {
    const activityEvents = ['mousemove', 'keydown', 'click'];
    activityEvents.forEach(event => window.addEventListener(event, resetActivityTimer));

    const interval = setInterval(() => {
      if (Date.now() - lastActivityTime > INACTIVITY_TIMEOUT_MS) {
        setIsSessionLocked(true);
      }
    }, 5000); // Check every 5 seconds

    return () => {
      activityEvents.forEach(event => window.removeEventListener(event, resetActivityTimer));
      clearInterval(interval);
    };
  }, [lastActivityTime]);

  const handleReauthenticate = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      // In a real scenario, this would call a backend endpoint to re-verify the password
      // For now, a mock check. Replace with actual API call.
      const response = await fetch(`${adminPath}/re-authenticate`, { // New endpoint to create
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
        credentials: 'include'
      });

      if (response.ok) {
        setIsSessionLocked(false);
        setPassword('');
        resetActivityTimer(); // Reset timer on successful re-auth
      } else {
        const data = await response.json();
        setError(data.error || 'Şifre yanlış veya oturum geçersiz.');
      }
    } catch (err) {
      setError('Yeniden kimlik doğrulama sırasında bir hata oluştu.');
    }
  };


  return (
    <div className="bg-blue-900 min-h-screen flex text-white">
      <Sidebar />
      <main className={`flex-1 p-8 relative ${isSessionLocked ? 'filter blur-md pointer-events-none' : ''}`}>
        <Outlet />
        {isSessionLocked && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg text-gray-900 dark:text-white max-w-sm w-full">
              <h2 className="text-2xl font-bold mb-4">Oturum Kilitlendi</h2>
              <p className="mb-4">Güvenliğiniz için oturumunuz kilitlenmiştir. Devam etmek için şifrenizi girin.</p>
              <form onSubmit={handleReauthenticate}>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Şifrenizi girin"
                  className="w-full px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required
                />
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                <button
                  type="submit"
                  className="mt-4 w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Oturumu Aç
                </button>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default AdminLayout;
